// extracted by mini-css-extract-plugin
export default {"root":"RdSyY","requirement":"_3ZblE","description":"dApdh","fulfilled":"_3BEnI","notFulfilled":"_7UNLJ"};